import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const fetchSupervisorsWithStatus = async () => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    query: graphql(`
      query SupervisorsWithStatus {
        supervisorsWithStatus {
          id
          firstName
          lastName
          status
        }
      }
    `),
  });

  return response.data.supervisorsWithStatus;
};
